export const apiCreate = (): string => '/commercial/menuFoodTypes/create'
export const apiList = (id?: string): string =>
  !id ? '/commercial/menuFoodTypes/' : `/commercial/menuFoodTypes/view/${id}`
export const apiUpdate = (id: string): string =>
  `/commercial/menuFoodTypes/update/${id}`
export const apiDelete = (id: string): string =>
  `/commercial/menuFoodTypes/delete/${id}`
